"use client";
import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import useTranslation from "translations/hooks/useTranslation";
import CountryCodeInput from "./CountryCodeInput";
import Input from "./Input";
import { Box } from "@material-ui/core";

const PhoneInputComponent = ({
  lang,
  onChange,
  phone_number,
  phone_valid,
  showError = false,
  name = "phoneNumber",
  countryCode = "",
  nameCode = "countryCode",
  onChangeCode = () => {},
  direction = "ltr",
  placeholder,
  title,
  countryCodeTitle,
  showCode = true,
  disabled,
  required = false,
  readOnly = false,
  className = "",
  codeClassName = "",
  containerClassName = "",
}) => {
  const { t } = useTranslation();
  const [phone, setPhone] = useState(phone_number);
  const [code, setCode] = useState(countryCode);

  useEffect(() => {
    setPhone(phone_number);
    setCode(countryCode);
  }, [phone_number, countryCode]);

  const handleChange = (e) => {
    setPhone(e.target.value);
    onChange(e);
  };

  const handleChangeCode = (value) => {
    setCode(value.dial_code);
    onChangeCode(value?.dial_code);
  };

  return (
    <div
      className={`flex flex-col tablet:flex-row w-full gap-4 ${containerClassName}`}
    >
      {showCode && (
        <div className="w-full tablet:w-[40%]">
          <CountryCodeInput
            nameCode={nameCode}
            selectedCode={code}
            onChange={handleChangeCode}
            direction={direction}
            title={countryCodeTitle}
            required={required}
            disabled={disabled}
            readOnly={readOnly}
            className={`h-[41px] ${codeClassName}`}
          />
        </div>
      )}
      <div className={showCode ? "w-full tablet:w-[60%]" : "w-full"}>
        <Input
          name={name}
          value={phone}
          onChange={handleChange}
          direction={direction}
          placeholder={placeholder}
          title={title}
          required={required}
          disabled={disabled}
          readOnly={readOnly}
          className={`h-[41px] ${className}`}
        />
      </div>
      {/* Display error message if showError is true */}
      {showError && (
        <div className="flex items-center text-red-500 font-medium mt-2">
          <Icon
            icon="mdi:alert-circle"
            className="mr-2"
            width={20}
            height={20}
          />
          <span>{t("fillFormFields")}</span>
        </div>
      )}
    </div>
  );
};

export default PhoneInputComponent;
